import React from "react";
import ClientTestimonial from "../components/ClientTestimonial";
import faqImage from "../assets/images/faq_img.webp";
import v1 from "../assets/images/v1.webp";
import v2 from "../assets/images/v2.webp";
import v3 from "../assets/images/v3.webp";
import w1 from "../assets/images/w1.webp";
import w2 from "../assets/images/w2.webp";
import w3 from "../assets/images/w3.webp";
import Faq from "../components/Faq";
import MailBox from "../assets/icons/MailBox";
import Call from "../assets/icons/Call";
import Rightarrow from "../assets/icons/Rightarrow";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";



const WhyUs = () => {
  const { t } = useTranslation();
  let faqs = [
  { question: t("how_do_i_place_an_order_on_loadinn"), answer: t("to_place_an_order_log_in_select_restaurant_choose_items_checkout") },
  { question: t("can_i_order_from_multiple_restaurants_at_the_same_time"), answer: t("orders_must_be_placed_separately_for_each_restaurant") },
  { question: t("can_i_schedule_an_order_for_later"), answer: t("yes_you_can_schedule_for_later_time") },
  { question: t("what_payment_methods_are_accepted"), answer: t("we_accept_cards_apple_google_wallet") },
  { question: t("are_there_any_hidden_charges"), answer: t("all_charges_displayed_before_confirm") },
  { question: t("can_i_add_a_tip_for_the_delivery_driver"), answer: t("tip_option_through_platform") },
  { question: t("how_can_i_track_my_order"), answer: t("track_order_via_website_or_email") },
  { question: t("can_i_contact_the_delivery_driver"), answer: t("yes_you_can_contact_driver") },
  { question: t("what_if_my_delivery_is_delayed"), answer: t("delivery_issue_contact_support") },
  { question: t("can_i_cancel_my_order_after_placing_it"), answer: t("cancellation_no_refund") },
  { question: t("under_what_conditions_can_i_get_a_refund"), answer: t("refund_if_order_not_ready_after_hour") },
  { question: t("how_long_does_it_take_for_a_refund_to_process"), answer: t("refund_credited_to_wallet") },
  { question: t("do_i_need_an_account_to_place_an_order"), answer: t("must_create_account") },
  { question: t("what_if_i_forget_my_password"), answer: t("reset_password_anytime") },
  { question: t("how_can_i_contact_customer_support"), answer: t("reach_us_via_chat_support") },
];

let slContent = [
  {
    title: "a_partner_centric_approach_to_your_success",
    description: "partner_centric_description",
  },
  {
    title: "expanded_customer_reach",
    description: "expanded_customer_reach_description",
  },
  {
    title: "simple_integration_intuitive_management_tools",
    description: "simple_integration_description",
  },
  {
    title: "couriers_who_care_about_your_food",
    description: "couriers_who_care_description",
  },
  {
    title: "data_driven_growth_insights",
    description: "data_driven_growth_description",
  },
  {
    title: "fair_and_transparent_partnership_terms",
    description: "fair_transparent_terms_description",
  },
  {
    title: "always_available_support_and_marketing_perks",
    description: "always_available_support_description",
  },
];
  return (
    <React.Fragment>
      <section className="rest_banner">
        <div className="wrapper">
          <div className="rest_bntext">
            <h1 className="usable_title">{t("why_to_choose_us")}</h1>
          </div>
        </div>
      </section>

      <section className="wh_section">
        <div className="wrapper">
          <h2 className="subtitle_common">
            {t("wide_variety_of_choices")}
          </h2>
          <div className="cta_grid variety_section">
            <div className="fcs_grd_clmn">
              <img src={v1} alt={t("we_believe_food_should_cater_to_everyone")} />
              <p className="para_common">{t("we_believe_food_should_cater_to_everyone")}</p>
            </div>
            <div className="fcs_grd_clmn">
              <img src={v2} alt={t("menu_includes_options_for_every_preference")} />
              <p className="para_common">{t("menu_includes_options_for_every_preference")}</p>
            </div>
            <div className="fcs_grd_clmn">
              <img src={v3} alt={t("curating_diverse_range_of_meals")} />
              <p className="para_common">{t("curating_diverse_range_of_meals")}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cm_grid">
        <div className="wrapper">
          <div className="client_main_grid why_grid">
            <img src={w1} alt={t("reliable_and_fast_delivery")} />
            <div className="wh_content">
              <h2 className="subtitle_common">{t("reliable_and_fast_delivery")}</h2>
              <ul>
                <li>{t("delivery_service_peak_condition")}</li>
                <li>{t("real_time_tracking")}</li>
                <li>{t("experienced_delivery_drivers")}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="cm_grid">
        <div className="wrapper">
          <div className="client_main_grid why_grid res_order">
            <div className="wh_content">
              <h2 className="subtitle_common">{t("user_friendly_technology")}</h2>
              <ul>
                <li>{t("smooth_and_convenient_ordering")}</li>
                <li>{t("real_time_tracking_and_secure_payments")}</li>
              </ul>
            </div>
            <img src={w2} alt={t("user_friendly_technology")} />
          </div>
        </div>
      </section>

      <section className="cm_grid">
        <div className="wrapper">
          <div className="client_main_grid why_grid">
            <img src={w3} alt={t("affordable_pricing_and_promotions")} />
            <div className="wh_content">
              <h2 className="subtitle_common">{t("affordable_pricing_and_promotions")}</h2>
              <ul>
                <li>{t("customers_at_heart")}</li>
                <li>{t("listen_to_feedback")}</li>
                <li>{t("go_above_and_beyond")}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="wh_section">
        <div className="wrapper">
          <h2 className="subtitle_common">{t("couriers")}</h2>
          <div className="cta_grid curior_scs variety_section">
            <div className="fcs_grd_clmn">
              <h3>{t("competitive_earnings")}</h3>
              <p className="para_common">{t("earnings_text")}</p>
            </div>
            <div className="fcs_grd_clmn">
              <h3>{t("flexible_scheduling")}</h3>
              <p className="para_common">{t("flexible_scheduling_text")}</p>
            </div>
            <div className="fcs_grd_clmn">
              <h3>{t("support_and_resources")}</h3>
              <p className="para_common">{t("support_and_resources_text")}</p>
            </div>
            <div className="fcs_grd_clmn">
              <h3>{t("reliable_and_transparent_payments")}</h3>
              <p className="para_common">{t("reliable_and_transparent_payments_text")}</p>
            </div>
            <div className="fcs_grd_clmn">
              <h3>{t("local_delivery_focus")}</h3>
              <p className="para_common">{t("local_delivery_focus_text")}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="wh_section">
        <div className="wrapper">
          <h2 className="subtitle_common">{t("restaurant")}</h2>
          <div className="cta_grid curior_scs variety_section rst_scs">
            {slContent.map((benefit, index) => (
              <div className="fcs_grd_clmn" key={index}>
                <h3>{t(benefit.title)}</h3>
                <p className="para_common">{t(benefit.description)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ClientTestimonial />

      <section className="bg_image_yellow bg_cta_scs">
        <div className="wrapper">
          <div className="bg_cta_scs_cont">
            <h2 className="subtitle_common">{t("get_started")}</h2>
            <p className="para_common">{t("get_started_text")}</p>
            <Link href="#" className="btn btn-secondary">
              {t("register_your_restaurant_now")} <Rightarrow />
            </Link>
          </div>
        </div>
      </section>

      <Faq faqs={faqs} faqimg={faqImage} />

      <section className="bg_image_yellow">
        <div className="wrapper">
          <div className="cta_grid">
            <div className="cta_title">
              <h2 className="subtitle_common">{t("need_help")}</h2>
              <p className="para_common">{t("need_help_text")}</p>
            </div>
            <div className="cta_buttons">
              <Link href="mailto:example@gmail.com" className="btn btn-primary">
                <MailBox /> {t("email_us")}
              </Link>
              <Link href="tel:9191919191" className="btn btn-primary">
                <Call /> {t("call_us")}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default WhyUs;
